import { RootState } from '../store';

export const ordersSelector = (state: RootState) => state.orders;

export const ordersEnabledSelector = (state: RootState) => state.orders.enabled;
